/**
 * BEKAJ BAU – Zentrale Compliance-Konfiguration
 * =============================================
 * Umsetzung der Transparenzpflichten gemaess EU AI Act (Verordnung (EU) 2024/1689),
 * insbesondere Art. 50 Abs. 1 (Interaktion natuerlicher Personen mit einem KI-System).
 *
 * Wirksam ab: 02. August 2026
 *
 * Alle KI-Funktionen der Website MUESSEN ihre Transparenzhinweise ueber diese
 * Datei beziehen. Neue KI-Features erben so automatisch die Compliance.
 */

// Master-Schalter: KI-Transparenzhinweise aktiv anzeigen
export const AI_DISCLOSURE_ENABLED = true;

// Zentraler Text-Baustein fuer alle KI-Systeme (Art. 50 Abs. 1)
export const AI_DISCLOSURE = {
  // Kurzform (Header, Buttons, Chips)
  shortLabel: 'KI',
  shortLabelLong: 'KI-Assistent',

  // Standard-Kennzeichnung fuer den Chatbot-Header
  chatbotName: 'KI Projekt-Assistent',

  // Erst-Interaktions-Hinweis (Art. 50 Abs. 1 – "at the time of the first interaction")
  firstInteractionNotice:
    'Hinweis: Sie chatten mit einem KI-basierten Assistenten (kein Mensch). '
    + 'Ihre Angaben werden zur Bearbeitung Ihrer Anfrage verarbeitet.',

  // Kurzer Inline-Hinweis (z.B. unter dem Header)
  inlineNotice: 'Sie chatten mit einer KI.',

  // Link auf die Datenschutz-Sektion mit KI-Details
  privacyLink: '/datenschutz#ki',
  privacyLinkLabel: 'Datenschutz',

  // Rechtsgrundlage (fuer Compliance-Report/Tooltip)
  legalBasis: 'Art. 50 Abs. 1 EU AI Act (Verordnung (EU) 2024/1689)',
};

/**
 * Registry aller KI-Systeme dieser Anwendung.
 * Wird vom Compliance-Report gelesen. Neue KI-Features hier registrieren.
 */
export const AI_SYSTEM_REGISTRY = [
  {
    id: 'projekt-assistent-chat',
    name: 'Projekt-Assistent (Chatbot)',
    surface: 'frontend',
    userFacing: true,
    art50Applies: true,
    disclosureRequired: true,
    implementation: 'ChatWidget.js – Header-Badge, Greeting, Inline-Banner',
    modelProvider: 'Emergent LLM (OpenAI GPT-5.2 / Gemini)',
  },
  {
    id: 'ai-lead-analysis',
    name: 'KI-Lead-Analyse (Score & Zusammenfassung)',
    surface: 'backend/admin',
    userFacing: false, // nur intern im Admin sichtbar
    art50Applies: false,
    disclosureRequired: false,
    implementation: 'Admin > AI-Chat Leads – bereits als "AI-ANALYSE" gekennzeichnet',
    modelProvider: 'Emergent LLM (OpenAI GPT-5.2)',
  },
  {
    id: 'static-website-copy',
    name: 'Statische Website-Texte',
    surface: 'frontend',
    userFacing: true,
    art50Applies: false, // kein interaktives KI-System i.S.v. Art. 50
    disclosureRequired: false,
    implementation: 'n/a',
    modelProvider: 'n/a',
  },
];

export default AI_DISCLOSURE;
